// extracted by mini-css-extract-plugin
export var underlinedLink = "_t1-0";